import { Box } from '@mui/material'

interface EntityDetailLayoutProps {
  sidebar: React.ReactNode
  children: React.ReactNode
  sidebarWidth?: number | string
  gap?: number
}

export const EntityDetailLayout = ({
  sidebar,
  children,
  sidebarWidth = 280,
  gap = 2.5,
}: EntityDetailLayoutProps) => {
  return (
    <Box sx={{ display: 'flex', gap, p: 3, pt: 2, alignItems: 'flex-start', flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
      {/* Sidebar */}
      <Box sx={{ width: sidebarWidth, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {sidebar}
      </Box>

      {/* Main Content */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {children}
      </Box>
    </Box>
  )
}
